/**
 * @deprecated It is better to set your script at the end of the page to have a more native feel for end of loading state.
 *  By using this function or any other function you risk waiting on images frames and videos to be loaded as well.
 *
 * @param fn
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var ready = function(fn) {
    if (document.readyState !== "loading") {
        if (_instanceof(fn, Function)) {
            fn(null);
        }
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
};
var _default = ready;
